export default props => ({
	type: 'application/ld+json',
	name: props.name,
	innerHTML: JSON.stringify(props.getAttributes())
})
